import PropTypes from 'prop-types';

import {
  DisabledDefaultProps,
  DisabledPropTypes,
} from '@/common/proptypes/Base/Disabled.proptypes';
import {
  IsLoadingDefaultProps,
  IsLoadingPropTypes,
} from '@/common/proptypes/Base/IsLoading.proptypes';
import {
  CartDefaultProps,
  CartPropTypes,
} from '@/common/proptypes/Cart/Cart.proptypes';
import {
  WarehouseDefaultProps,
  WarehousePropTypes,
} from '@/common/proptypes/Common/Warehouse/Warehouse.proptypes';

export const ScanbatDefaultProps = {
  ...DisabledDefaultProps,
  ...IsLoadingDefaultProps,
  cart: { ...CartDefaultProps },
  company: null,
  refetchCart: () => {},
  warehouse: { ...WarehouseDefaultProps },
};

export const ScanbatPropTypes = {
  ...DisabledPropTypes,
  ...IsLoadingPropTypes,
  cart: PropTypes.shape({ ...CartPropTypes }),
  company: PropTypes.string,
  refetchCart: PropTypes.func,
  warehouse: PropTypes.shape({ ...WarehousePropTypes }),
};
